import React, { FC } from 'react';
import styled from 'styled-components';

import ChatCampaignsSettingModalForm from 'src/presentation/components/pages/proactiveChat/ChatCampaignsSettingModalForm';
import chatCampaignSettingsResource from 'src/actions/chatCampaigns/chatCampaignSettingsResource';
import EmbedModalWithGreenHeader from 'src/presentation/components/pages/shared/EmbedModalWithGreenHeader';
import { isLoadingStatus } from 'src/presentation/hooks/useResource';
import { ModalSize } from 'src/presentation/components/pages/shared/EmbedModal';
import { Spinner } from 'src/presentation/components/pages/shared/Spinner';

import useDocumentResource from 'src/presentation/hooks/useDocumentResource';

const ChatCampaignsSettingModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const { errors, loadingState, value } = useDocumentResource(chatCampaignSettingsResource);

  return (
    <StyledModal
      data-aid="proactive-chat-settings-modal"
      title="Settings"
      content={
        <div>
          {isLoadingStatus(loadingState) ? (
            <SpinnerWrapper>
              <Spinner />
            </SpinnerWrapper>
          ) : (
            <ChatCampaignsSettingModalForm errors={errors} onClose={onClose} item={value} root="proactive-chat" />
          )}
        </div>
      }
      onCancel={onClose}
      modalSize={ModalSize.EXTRALARGE}
    />
  );
};

const StyledModal = styled(EmbedModalWithGreenHeader)`
  padding: 0;
`;

const SpinnerWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  min-height: 297px;
`;

export default ChatCampaignsSettingModal;
